
import CONSTANTS from '../constants';
import globalState from '../state';
import { formataDataWebMethodParaString } from '../modules/util';

let solicitante = (state = globalState.solicitante, action) => {

    let actions = {
        [CONSTANTS.CHANGE_GENERICO_SOLICITANTE](state, action) {
            if (action.payload.id === 'solTipo') {
                return   { ...state, solTipo: 'J'.charCodeAt(0).toString() };
            }

            let obj = {
                [action.payload.id]: action.payload.valor
            };

            return { ...state, ...obj };
        },

        [CONSTANTS.CARREGAR_AREAS.SUCCESS](state, action) {

            return { ...state, listAreas: action.payload };
        },

        [CONSTANTS.CHANGE_AREA](state, action) {

            var listAreasSelecionadas = state.listAreasSelecionadas;

            if (action.payload.acao === 'add') {
                listAreasSelecionadas = [...listAreasSelecionadas, Number(action.payload.id)];
            } else {
                listAreasSelecionadas = listAreasSelecionadas.filter((item) => {
                    return Number(item) !== Number(action.payload.id);
                });
            }

            return { ...state, listAreasSelecionadas: listAreasSelecionadas };
        },

        [CONSTANTS.CARREGAR_LIST_CIDADES.LOADING](state, action) {
            return { ...state, carregandoCidades: true };
        },

        [CONSTANTS.CARREGAR_LIST_CIDADES.SUCCESS](state, action) {

            if (action.payload.tipo === 'projeto') {
                return { ...state, carregandoCidades: false, listCidadesProjeto: action.payload.list };
            } else {
                return { ...state, carregandoCidades: false, listCidades: action.payload.list };
            }
        },
        [CONSTANTS.CONSULTA_CEP.LOADING]: (state, action) => {
            let payload = action.payload;
            if (payload.tipo === 'solicitante') {
                return { ...state, carregandoCEP: true };
            }
            return { ...state, carregandoCEPProjeto: true };
        },
        [CONSTANTS.CONSULTA_CEP.ERROR]: (state, action) => {
            return { ...state, carregandoCEP: false, carregandoCEPProjeto: false };
        },
        [CONSTANTS.CONSULTA_CEP.SUCCESS]: (state, action) => {
            let payload = action.payload;
            var cep = {};
            if (payload.tipo === 'solicitante') {
                cep = {
                    carregandoCEP: false,
                    solBairro: payload.bairro.toUpperCase(),
                    solEndereco: payload.rua.toUpperCase(),
                    solUF: payload.uf.toUpperCase()
                };

            } else {
                cep = {
                    carregandoCEPProjeto: false,
                    solBairroProjeto: payload.bairro.toUpperCase(),
                    solLocalProjeto: payload.rua.toUpperCase(),
                    solUFProjeto: payload.uf.toUpperCase()
                };
            }

            return { ...state, ...cep };
        },

        [CONSTANTS.GET_PESSOA_DADOS.LOADING](state, action) {
            return { ...state, carregandoCPF: true };
        },
        [CONSTANTS.GET_PESSOA_DADOS.ERROR](state, action) {
            return { ...state, carregandoCPF: false };
        },

        [CONSTANTS.GET_PESSOA_DADOS.SUCCESS]: (state, action) => {
            let payload = action.payload;
            var dadosPessoa = payload.dadosPessoa;
            console.log(dadosPessoa);

            var pessoa = {

            };

            if (dadosPessoa) {
                pessoa = {
                    solNome: dadosPessoa.PesNome.trim(),
                    solDtnascimento: formataDataWebMethodParaString(dadosPessoa.PesDatnas),
                    solFone: dadosPessoa.PesCelular || dadosPessoa.PesTelefone,
                    solEmail: dadosPessoa.Email,
                    solCep: dadosPessoa.PesCep,
                    solBairro: dadosPessoa.PesBairro,
                    solEndereco: dadosPessoa.PesRua,
                    locCodEndereco: dadosPessoa.LocCodigo
                }

            }
            return {
                ...state,
                ...pessoa,
                carregandoCPF: false

            };
        },




        [CONSTANTS.VERIFICA_LIBERACAO.LOADING](state, action) {
            return { ...state, carregandoLiberado: true };
        },

        [CONSTANTS.VERIFICA_LIBERACAO.SUCCESS](state, action) {
            return { ...state, liberado: true, carregandoLiberado: false };
        },

        [CONSTANTS.VERIFICA_LIBERACAO.ERROR](state, action) {

            return { ...state, carregandoLiberado: false };
        },
        [CONSTANTS.GRAVAR_SOLICITANTE.LOADING](state, action) {
            return { ...state, gravandoSolicitante: true };
        },

        [CONSTANTS.GRAVAR_SOLICITANTE.SUCCESS](state, action) {
            return { ...state, gravandoSolicitante: false };
        },

        [CONSTANTS.GRAVAR_SOLICITANTE.ERROR](state, action) {

            return { ...state, gravandoSolicitante: false };
        },

        [CONSTANTS.RESET_SOLICITANTE](state, action) {


            var obj = {
                solUF: 'SP',
                solUFProjeto: 'SP',
                "listAreasSelecionadas": [],
                "solOrigem": "",
                "solCnpjCpf": "",
                "solNome": "",
                "solDtnascimento": "",
                "solFone": "",
                "solEmail": "",
                "solCep": "",
                "solBairro": "",
                "solEndereco": "",
                "locCodEndereco": "",
                "solTituloProjeto": "",
                "solCepProjeto": "",
                "solBairroProjeto": "",
                "solLocalProjeto": "",
                "locCodProjeto": "",
                "solDescricaoProje": "",
                "solAcoes": "",
                "solQtdVoluntario": "",
                "solBeneficio": "",
                "solDtinicio": "",
                "solDtfim": "",
                solContato: "",
                solPublico: "",
                solAcaoResp: "",
                solTecResp: "",
                solNumConselho: ""
            };
            return { ...state, ...obj };
        },
    };

    if (actions[action.type]) {
        return actions[action.type](state, action);
    }

    return state;
};


export default solicitante;